var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list', {
    staticClass: "py-0",
    class: {
      'isMobile': _vm.isMobile
    }
  }, _vm._l(_vm.links, function (link, i) {
    return _c('div', {
      key: i
    }, [_c('v-list-item', {
      staticClass: "pr-2 pl-2",
      class: {
        'pl-1': _vm.isMobile
      },
      attrs: {
        "to": link.route,
        "active-class": "activeLink"
      }
    }, [_c('v-list-item-icon', {
      staticClass: "mr-3 my-3 ml-2"
    }, [_c('v-icon', {
      staticClass: "menu--text",
      attrs: {
        "title": link.text
      }
    }, [_vm._v(_vm._s(link.icon))])], 1), _c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "menu--text"
    }, [_vm._v(_vm._s(link.text))])], 1)], 1)], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }